<template>
  <div>
    <div id="All">
      <div class="all_left">
        <div class="left_top">
          <div class="sale">
            <p>销售额</p>
            <span>(RMB `000)</span>
          </div>
          <b>{{salesValue|NumFormat}}</b>
        </div>
        <div class="left_top">
          <div class="sale">
            <p>对比去年</p>
            <span></span>
          </div>
          <b>{{ly}}</b>
        </div>
      </div>
      <div class="middle"></div>
      <div class="all_right">
        <!-- <p>同比增长</p> -->
        <Circular :Proportion="Proportion" :MyGone='Gone' :bindEl="bindEl"></Circular>
      </div>
    </div>
  </div>
</template>
<script>
import Circular from "./ButThr_Cricle";
import qs from "qs";

export default {
  data() {
    return {
      Proportion: 0,
      salesValue: 0,
      targetValue: 0,
      bindEl: "PosAll",
      ly: 0,
      time: "",
      Gone: "",
    };
  },
  components: {
    Circular,
  },
  methods: {
    getSum(time) {
      this.$addr
        .post(
          "weekly/getSalesSumData",
          qs.stringify({ weeklyFlag: 1, monthFrom: time, monthTo: time })
        )
        .then((res) => {
          this.achieving = res.data.data[0].achieving;
          this.salesValue = res.data.data[0].salesValue;
          this.targetValue = res.data.data[0].targetValue;
          this.ly = res.data.data[0].ly;
          this.Proportion = res.data.data[0].ly;
        });
    },
  },
  created() {},
  props: ["MyTimeDef2", "MyTimeGone"],
  watch: {
    MyTimeDef2: {
      handler(newValue, oldValue) {
        this.time = newValue;
        this.getSum(this.time);
      },
      deep: true,
    },
    MyTimeGone: {
      handler(newValue, oldValue) {
        this.Gone = newValue;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
#All {
  overflow: hidden;
  clear: both;
  display: flex;
  box-sizing: border-box;
  text-align: center;
}
.all_left {
  width: 225px;
  margin: 52px 19px 50px 32px;
}
.all_left .left_top {
  display: flex;
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  justify-content: space-between;
}
.all_left .left_top p {
  line-height: 28px;
  color: #191919;
  flex: 1;
  min-width: 80px;
  text-align: right;
}
.all_left .left_top span {
  line-height: 18px;
  color: rgba(13, 13, 13, 0.3);
}
.sale {
  text-align: right;
  margin: 0 12px 26px 0;
}
.all_left .left_top b {
  opacity: 0.91;
  font-family: "Arial-BoldMT";
  font-size: 22px;
  color: #282828;
  text-align: center;
}
.middle {
  margin: 20px 0;
  width: 1px;
  height: 160px;
  border: 1px solid rgba(157, 157, 157, 0.4);
}
.all_right {
  margin: 24px 31px 22px 19px;
  width: 187px;
  text-align: center;
  position: relative;

}
.all_right p {
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  color: #191919;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/ButThr/ButThr_Posall.vue